<template>
    <div class="d-flex align-items-center justify-content-between totalR whiteBG bg-white border-radius-5 p-3" v-if="totalRecords > 0">
        <p class="m-0">
            Total Records <span class="totalRecords">{{totalRecords}}</span>
        </p> 
        <paginate
            v-if="totalRecords > limit"
            :page-count="Math.ceil(totalRecords/limit)"
            :page-range="3"
            :click-handler="fetchData"
            :prev-text="'Prev'"
            :next-text="'Next'" 
            :container-class="'pagination'"
            :hide-prev-next="true"
            :force-page="parseInt(pageNo)">
        </paginate>
    </div>
</template>
<script>
    export default {
        name: 'PAGINATION',
        data () {
            return { }
        },
        props:['totalRecords','limit','pageNo'],
        methods:{
            fetchData(pageNum){
                this.$parent.page = pageNum
                try { 
                    this.$parent.listing() 
                } catch (e) {}
                
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/shared/pagination.vue